export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/DealerCarBadge.c93f4ee3.svg","height":96,"width":114,"blurWidth":0,"blurHeight":0};